import { useSearchParams } from 'next/navigation';

const PROMOCODE_QUERY = 'code';

export const usePromocodeFromQuery = () => {
  const searchParams = useSearchParams();

  const promocode = searchParams.get(PROMOCODE_QUERY);

  return promocode;
};
